<template>
  <!-- Add animated background -->
  <div class="animated-background">
    <div class="floating-elements">
      <span class="element code">{ }</span>
      <span class="element book">📚</span>
      <span class="element graduation">🎓</span>
      <span class="element tech">💻</span>
      <span class="element atom">⚛️</span>
      <span class="element formula">∑</span>
      <span class="element infinity">∞</span>
      <span class="element binary">01</span>
      <span class="element circuit"></span>
      <span class="element grid"></span>
    </div>
  </div>
  <div dir="rtl">
    <!-- First row: Page title -->
    <div class="mb-4">
      <h1>مساحات الدراسة</h1>
    </div>
    
    <!-- Second row: Add button and search bar -->
    <div class="d-flex mb-4">
      <div style="width: 25%; padding-left: 16px;">
        <v-btn 
          color="primary" 
          @click="showAddDialog = true" 
          block
          height="56px"
          class="mt-n1"
        >
          <v-icon start>mdi-plus</v-icon>
          إضافة مساحة دراسة
        </v-btn>
      </div>
      <div style="width: 75%;">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="بحث"
          single-line
          hide-details
          class="rtl-input"
        ></v-text-field>
      </div>
    </div>

    <!-- Main table -->
    <v-data-table
      :headers="headers"
      :items="spaces"
      :search="search"
      :loading="isLoading"
      :items-per-page="10"
      class="elevation-1 rtl-table"
    >
      <template #[`item.active`]="{ item }">
        <v-chip
          :color="getStatusColor(item.active)"
          text-color="white"
          size="small"
        >
          {{ getStatusText(item.active) }}
        </v-chip>
      </template>
      <template #[`item.features`]="{ item }">
        <div class="features-container">
          <v-tooltip v-if="item.wifi" bottom>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" color="primary" class="mx-1">mdi-wifi</v-icon>
            </template>
            <span>واي فاي</span>
          </v-tooltip>
          
          <v-tooltip v-if="item.pc" bottom>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" color="primary" class="mx-1">mdi-laptop</v-icon>
            </template>
            <span>حاسوب</span>
          </v-tooltip>
          
          <v-tooltip v-if="item.coffee" bottom>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" color="primary" class="mx-1">mdi-coffee</v-icon>
            </template>
            <span>شاي/قهوة</span>
          </v-tooltip>
          
          <v-tooltip v-if="item.printing_docs" bottom>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" color="primary" class="mx-1">mdi-printer</v-icon>
            </template>
            <span>طباعة مستندات</span>
          </v-tooltip>
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small  @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-3" @click="deleteItem(item)" v-if="hasDeletePermission">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <!-- Add/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="600px" class="rtl-dialog">
      <v-card class="rtl">
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row style="direction: rtl;">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.name"
                  label="الاسم"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.capacity"
                  label="السعة"
                  type="number"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.price_per_hour"
                  label="السعر بالساعة"
                  type="number"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.price_per_day"
                  label="السعر باليوم"
                  type="number"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.price_per_week"
                  label="السعر بالأسبوع"
                  type="number"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.price_per_month"
                  label="السعر بالشهر"
                  type="number"
                  required
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="editedItem.wifi"
                  label="واي فاي"
                  color="primary"
                  class="rtl-input"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="editedItem.pc"
                  label="حاسوب"
                  color="primary"
                  class="rtl-input"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="editedItem.coffee"
                  label="شاي/قهوة"
                  color="primary"
                  class="rtl-input"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="editedItem.printing_docs"
                  label="طباعة مستندات"
                  color="primary"
                  class="rtl-input"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch
                  v-model="editedItem.active"
                  label="نشط"
                  color="success"
                  class="rtl-input"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.note"
                  label="ملاحظات"
                  class="rtl-input"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            text
            @click="close"
          >
            إلغاء
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="save"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px" class="rtl-dialog">
      <v-card class="rtl">
        <v-card-title class="text-h5">هل أنت متأكد من حذف هذا العنصر؟</v-card-title>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click="closeDelete"
          >
            إلغاء
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteItemConfirm"
          >
            تأكيد
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'StudySpaceComponent',
  data() {
    return {
      search: '',
      dialog: false,
      deleteDialog: false,
      showAddDialog: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        capacity: 0,
        price_per_hour: 0,
        price_per_day: 0,
        price_per_week: 0,
        price_per_month: 0,
        wifi: false,
        pc: false,
        coffee: false,
        printing_docs: false,
        active: true,
        note: ''
      },
      defaultItem: {
        id: null,
        name: '',
        capacity: 0,
        price_per_hour: 0,
        price_per_day: 0,
        price_per_week: 0,
        price_per_month: 0,
        wifi: false,
        pc: false,
        coffee: false,
        printing_docs: false,
        active: true,
        note: ''
      },
      headers: [
        { title: 'الاسم', key: 'name', align: 'center' },
        { title: 'السعة', key: 'capacity', align: 'center' },
        { title: 'المتاح', key: 'available', align: 'center' },
        { title: 'السعر بالساعة', key: 'price_per_hour', align: 'center' },
        { title: 'السعر باليوم', key: 'price_per_day', align: 'center' },
        { title: 'السعر بالأسبوع', key: 'price_per_week', align: 'center' },
        { title: 'السعر بالشهر', key: 'price_per_month', align: 'center' },
        { title: 'المميزات', key: 'features', align: 'center' },
        { title: 'الحالة', key: 'active', align: 'center' },
        { title: 'الإجراءات', key: 'actions', sortable: false, align: 'center' }
      ]
    };
  },
  computed: {
    ...mapState({
      spaces: state => state.space.spaces,
      isLoading: state => state.space.loading
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'إضافة مساحة دراسة' : 'تعديل مساحة دراسة';
    },
    hasDeletePermission() {
      return true; // For now, allow all users to delete
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    deleteDialog(val) {
      val || this.closeDelete();
    },
    showAddDialog(val) {
      if (val) {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.dialog = true;
        this.showAddDialog = false;
      }
    }
  },
  created() {
    this.fetchSpaces();
  },
  methods: {
    ...mapActions({
      fetchSpaces: 'space/fetchSpaces',
      addSpace: 'space/addSpace',
      updateSpace: 'space/updateSpace',
      deleteSpace: 'space/deleteSpace'
    }),
    getStatusColor(active) {
      return active ? 'success' : 'error';
    },
    getStatusText(active) {
      return active ? 'نشط' : 'غير نشط';
    },
    editItem(item) {
      this.editedIndex = this.spaces.findIndex(s => s.id === item.id);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.spaces.findIndex(s => s.id === item.id);
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async deleteItemConfirm() {
      try {
        await this.deleteSpace(this.editedItem.id);
        this.$store.dispatch('showAlert', {
          message: 'تم حذف مساحة الدراسة بنجاح',
          type: 'success'
        });
      } catch (error) {
        this.$store.dispatch('showAlert', {
          message: 'حدث خطأ أثناء حذف مساحة الدراسة',
          type: 'error'
        });
      }
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      try {
        // Convert string values to numbers
        const spaceData = {
          ...this.editedItem,
          capacity: parseInt(this.editedItem.capacity),
          price_per_hour: parseFloat(this.editedItem.price_per_hour),
          price_per_day: parseFloat(this.editedItem.price_per_day),
          price_per_week: parseFloat(this.editedItem.price_per_week),
          price_per_month: parseFloat(this.editedItem.price_per_month)
        };
        
        if (this.editedIndex > -1) {
          // Update existing space
          await this.updateSpace({ id: spaceData.id, spaceData });
          this.$store.dispatch('showAlert', {
            message: 'تم تحديث مساحة الدراسة بنجاح',
            type: 'success'
          });
        } else {
          // Add new space
          await this.addSpace(spaceData);
          this.$store.dispatch('showAlert', {
            message: 'تمت إضافة مساحة الدراسة بنجاح',
            type: 'success'
          });
        }
        this.close();
      } catch (error) {
        this.$store.dispatch('showAlert', {
          message: 'حدث خطأ أثناء حفظ مساحة الدراسة',
          type: 'error'
        });
      }
    }
  }
};
</script>

<!-- StudySpace specific styles only -->
<style scoped>
.rtl-table {
  direction: rtl;
}

.features-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.features-container .v-icon {
  margin: 0 4px;
}
</style>
